import { gql } from "@apollo/client";
export default function tag(...args) {
    let compiled = null;
    return {
        get kind () {
            if (!compiled) {
                compiled = gql(...args);
            }
            return compiled.kind;
        },
        get definitions () {
            if (!compiled) {
                compiled = gql(...args);
            }
            return compiled.definitions;
        },
        get loc () {
            if (!compiled) {
                compiled = gql(...args);
            }
            return compiled.loc;
        }
    };
}

//# sourceMappingURL=tag.js.map